'use client'

import GeneralForm from "components/GeneralForm";
import TabPanel from "components/TabPanel";
import TabView from "components/TabView";
import TitleFormWithEdit from "components/TitleFormWithEdit";
import { validate } from "components/validateGeneralForm";
import { useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Button, Card, CardBody, Container } from "reactstrap";
import { erroInesperado } from "services/Utils";
import modeloComponenteService from "services/ModeloComponenteService";
import comboService from "services/ComboService";
import Filhos from "./Filhos";

export default function FormModeloComponente() {
  const [data, setData] = useState({})
  const [edit, setEdit] = useState(false)
  const [tiposComponente, setTiposComponente] = useState([])
  const [marcas, setMarcas] = useState([])
  const params = useParams()
  const navigate = useNavigate()

  const id = parseInt(params.id)
  const novo = (0 === id)

  useEffect(() => {
    comboService.tipoComponente().then(res => {
      if (res.success) {
        setTiposComponente(res.data)
      }
    })
  }, [])

  useEffect(() => {
    comboService.marca().then(res => {
      if (res.success) {
        setMarcas(res.data)
      }
    })
  }, [])

  useEffect(() => {
    if (!!id) {
      modeloComponenteService.getById(id).then(res => {
        if (res.success) {
          setData(res.data)
        }
      })
    } else {
      setData({})
    }
  }, [id])

  useEffect(() => {
    if (novo) {
      setEdit(true)
    }
  }, [novo])

  const formConfig = useMemo(() => {
    return [
      [
        {
          name: "idTipoComponente", label: 'Tipo de Componente', type: "combo", required: true, colspan: 6,
          options: tiposComponente, optionValue: 'id', optionLabel: 'descricao', showDefault: true,
        },
        { name: "descricao", label: 'Descrição', type: "text", required: true, colspan: 6 },
      ],
      [
        {
          name: "idMarca", label: 'Marca', type: "combo", colspan: 6,
          options: marcas, optionValue: 'id', optionLabel: 'descricao', showDefault: true,
        },
      ]
    ]
  }, [data, tiposComponente, marcas])

  // tipo de componente selecionado no combo acima, com os campos extras do combo (aceitaFilhos)
  const tipoComponenteSelecionado = useMemo(() => {
    return tiposComponente.find(el => el.id == data.idTipoComponente)
  }, [tiposComponente, data.idTipoComponente])

  // aba de slots só faz sentido pra um modelo já salvo, de um tipo de componente que aceita filhos
  const abaFilhosHabilitada = !novo && !!tipoComponenteSelecionado?.aceitaFilhos

  const handleChange = (name, value) => {
    setData({ ...data, [name]: value })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    const errors = validate(formConfig, data)
    if (errors.length > 0) {
      setData({ ...data, errors })
      return
    }

    try {
      if (novo) {
        await modeloComponenteService.create(data)
      } else {
        await modeloComponenteService.update(id, data)
      }
      toast('Registro salvo com sucesso!')
      navigate('/admin/modelos-componente')
    } catch (ex) {
      erroInesperado()
    }

  }

  return (
    <Container fluid>
      <TitleFormWithEdit title="Modelos de Componente" edit={edit} onChangeEdit={setEdit} showButton={!novo} />

      <TabView>
        <TabPanel label="Dados">
          <Card>
            <CardBody>
              <form onSubmit={handleSubmit}>
                <GeneralForm
                  config={formConfig}
                  data={data}
                  onChange={handleChange}
                  disabled={!edit}
                />
                {edit && (
                  <Button type="submit" color="primary">Salvar</Button>
                )}
              </form>
            </CardBody>
          </Card>
        </TabPanel>
        <TabPanel label="Slots de Filhos" disabled={!abaFilhosHabilitada}>
          <Filhos idModeloComponente={id} edit={edit} />
        </TabPanel>
      </TabView>
    </Container>
  )
}
